import {FloatingSignUp} from "components/commons";
import CalculatorInfoSection from "../CalculatorInfoSection";
import Calculator from "./Calculator";
import React from "react";

const SipAndStepUpSipPageContent = () => (
  <>
    <Calculator />
    <FloatingSignUp />
    <CalculatorInfoSection slug="sip-step-up-sip" />
  </>
);

export default SipAndStepUpSipPageContent;
